import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import _cloneDeep from 'lodash/cloneDeep';

import { ClientsAmountFilter, ClientsRequestsFilter, ClientFilters } from '../Filters';
import ClientsListForNotification from '../../ClientNotification/ClientsListForNotification';
import { Pagination, Checkbox } from '../../utilites';
import AppDatePicker from '../../utilites/DateRangePicker/AppDatePicker';
import {permissionsAccess, useQuery} from '../../../helpers/common';
import SearchLoader from '../Loader/SearchLoader';
import { searchClients, getClientFacets } from '../../../redux/actions/searchAction';
import { changeClientList, openClientList, clientDeleted } from "../../../redux/actions/notificationAction";
import { buildRequest, getActiveFacets } from '../../../helpers/common';
import { ActionButton, AlertModal } from '../../common';
import { composeProfiles, resetClients } from '../../../redux/actions/clientsAction';

import '../search-results.scss';
import '../../../assets/styles/components/_tables.scss';

import CrossSmallIcon from '../../../assets/icons/cross-small.svg';
import NothingFoundImage from '../../../assets/images/no_data.svg';
import CombineProfileModal from './CombineProfileModal/CombineProfileModal';
import { calculateTotalPages, getCurrentPage } from '../helpers';

const ClientsSearchResults = () => {
  const { isLoadingPageClientSearch, clientFacetData, customerSearchResults } = useSelector(
    ({ search }) => search,
  );
  const amountRangeMinMax = useSelector(({ search }) => search.clientFacetData.amountRangeMinMax);
  const requestsRangeMinMax = useSelector(
    ({ search }) => search.clientFacetData.requestsRangeMinMax,
  );
  const { clients, openClientToNotificationList, deletedClient, messageSentSuccess } = useSelector(({ notification }) => notification);
  const { accessFeatures } = useSelector(({ user }) => user);
  const { loading } = useSelector(({ clients }) => clients);

  const query = useQuery();
  const history = useHistory();
  const queryTerm = useMemo(() => query.get('term'), []);

  const [filters, setFilters] = useState(() => ({
    ...clientFacetData,
    term: queryTerm,
  }));

  const [allChecked, setAllChecked] = useState(false);
  const [term, setTerm] = useState('');
  const [resetAmountFilter, setResetAmountFilter] = useState(false);
  const [resetRequestsFilter, setResetRequestsFilter] = useState(false);
  const [markedClients, setMarkedClients] = useState([]);
  const [popup, setPopup] = useState({
    isOpen: false,
    header: 'Ошибка',
    text: '',
  });
  const [combineProfiles, setCombineProfiles] = useState({
    isOpen: false,
    data: [],
  });

  const dispatch = useDispatch();

  const empty =
    customerSearchResults &&
    customerSearchResults.clients.length !== 0 &&
    markedClients.length !== 0;

  useEffect(() => {
    dispatch(getClientFacets(filters));

    return () => {
      dispatch(resetClients());
    };
  }, [dispatch]);

  useEffect(() => {
    if (messageSentSuccess) {
      const newArr = markedClients.map(el => ({
        ...el,
        check: false
      }));
      setMarkedClients(newArr)
    }
  }, [messageSentSuccess])

  useEffect(() => {
    if (customerSearchResults && customerSearchResults.clients.length) {
      setMarkedClients(
        customerSearchResults.clients.map(
          ({ lastName, firstName, middleName, personal, doc, id }) => ({
            fullName: `${lastName} ${firstName}${!!middleName ? (' ' + middleName) : ''}`,
            personal,
            doc,
            check: false,
            id,
          }),
        ),
      );
    }
  }, [customerSearchResults]);

  useEffect(() => {
    if (queryTerm && filters.term !== queryTerm) {
      const dataFilters = _cloneDeep(filters);
      dataFilters.term = queryTerm;
      dataFilters.currentPage = 1;
      setFilters(dataFilters);

      dispatch(searchClients(buildRequest(clientFacetData, dataFilters)));
    }

  }, [queryTerm, history, dispatch, clientFacetData]);

  useEffect(() => {
    if (resetAmountFilter) {
      setResetAmountFilter(false);
    }
  }, [resetAmountFilter]);

  useEffect(() => {
    if (resetRequestsFilter) {
      setResetRequestsFilter(false);
    }
  }, [resetRequestsFilter]);

  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      amountRangeMinMax,
      requestsRangeMinMax,
    }));
  }, [amountRangeMinMax, requestsRangeMinMax]);

  const handleFilterChange = (filterName, newValue) => {
    const dataFilters = _cloneDeep(filters);

    if (newValue !== 'currentPage') {
      dataFilters.currentPage = 1;
    }

    dataFilters[filterName] = newValue;
    setFilters(dataFilters);

    dispatch(searchClients(buildRequest(clientFacetData, dataFilters)));
    setAllChecked(false)
  };

  const resetRequests = () => {
    handleFilterChange('requestsRangeMinMax', [requestsRangeMinMax[0], requestsRangeMinMax[1]]);
    setResetRequestsFilter(true);
  };

  const resetAmount = () => {
    handleFilterChange('amountRangeMinMax', [amountRangeMinMax[0], amountRangeMinMax[1]]);
    setResetAmountFilter(true);
  };

  const resetDate = () => {
    handleFilterChange('timeRange', { startDate: null, endDate: null });
  };

  const triggerSearchInput = (e) => {
    const newTerm = e.target.value;
    if (e.key === 'Enter') {
      e.target.blur();
      handleFilterChange('term', newTerm);
      history.replace({ term: '' })
    }
  };

  const onChange = (e) => {
    setTerm(e.target.value);
  };

  const resetTerm = () => {
    history.replace({ term: '' });
    handleFilterChange('term', '');
    setTerm('');
  };

  useEffect(() => {
    let searchListClients =_cloneDeep(markedClients);

    if ( deletedClient && deletedClient !== 'all' ) {
      const matchedClientInx = searchListClients.findIndex((obj => obj.id === deletedClient))
      if(matchedClientInx !== -1) searchListClients[matchedClientInx].check = false
      dispatch(clientDeleted(''))
      setMarkedClients(searchListClients)
    } else if ( deletedClient === 'all' ) {
      searchListClients.map(obj => obj.check=false )
      dispatch(clientDeleted(''))
      setMarkedClients(searchListClients)
      setAllChecked(false)
    }
  }, [deletedClient, clients]);

  useEffect(() => {
    if ( openClientToNotificationList && allChecked ) {
      const newArray = _cloneDeep(markedClients);
  
      const array = [...clients, ...newArray];
      const set = new Set();

      const filteredArr = array.filter(el => {
        const duplicate = set.has(el.id);
        set.add(el.id);
        return !duplicate;
      });

      dispatch(changeClientList(filteredArr));
    }
  }, [allChecked, dispatch, openClientToNotificationList]);

  const handleClientCheck = (e) => {
    const id = markedClients.findIndex(({ id }) => id === e.target.id);
    const newArray = _cloneDeep(markedClients);
    newArray[id].check = !markedClients[id].check;

    if ( openClientToNotificationList && newArray[id].check ) {
      const duplicateClient = !!(!!clients.length && clients.find(item => item.id === newArray[id].id))
      if(!duplicateClient) {
        const newClientsList = [...clients, newArray[id]]
        dispatch(changeClientList(newClientsList))
      }
    }

    setMarkedClients(newArray);
  };

  const handleAllClientCheck = () => {
    setMarkedClients((prev) => prev.map((item) => ({ ...item, check: !allChecked })));
    setAllChecked(!allChecked)
  };

  const openClientsListForNotification = () => {
    dispatch(openClientList(true))
  }

  const closeAlertModal = () => {
    setPopup((prev) => ({ ...prev, isOpen: false, text: '' }));
  };

  const handleCombineProfiles = () => {
    const data = markedClients.filter(({ check }) => check);
    const condition = data.length;
    if (openClientToNotificationList) {
      setPopup((prev) => ({
        ...prev,
        isOpen: true,
        text: 'Ошибка! Закройте форму отправки СМС',
      }));
    }
    else {
      if (condition === 1) {
        setPopup((prev) => ({
          ...prev,
          isOpen: true,
          text: 'Не менее двух анкет',
        }));
      }
      if (condition > 3) {
        setPopup((prev) => ({
          ...prev,
          isOpen: true,
          text: 'Не более трёх анкет',
        }));
      }
      if (condition) {
        setCombineProfiles({isOpen: true, data});
      }
    }
  };

  const handleCloseModal = () => {
    setCombineProfiles((prev) => ({ ...prev, isOpen: false }));
  };

  const submitProfiles = () => {
    const listIds = combineProfiles.data.map(({ id }) => id).join(',');
    const dataFilters = _cloneDeep(filters);
    dataFilters.currentPage = 1;

    setFilters(dataFilters);
    dispatch(composeProfiles({ listIds, reqData: buildRequest(clientFacetData, dataFilters) }));
    handleCloseModal();
  };

  const handleAmountFilter = (v) => handleFilterChange('amountRangeMinMax', v);

  const handleRequestFilter = (v) => handleFilterChange('requestsRangeMinMax', v);

  return (
    <>
      <div className="content-inner-data-columns">
        <div className="content-inner-data-filters">
          {openClientToNotificationList && <ClientsListForNotification/>}
          {
              permissionsAccess("elastic.facets.client.total") &&
              <ClientsAmountFilter onChange={handleAmountFilter} reset={resetAmountFilter}/>
          }
          {
              permissionsAccess("elastic.facets.client.count") &&
              <ClientsRequestsFilter onChange={handleRequestFilter} reset={resetRequestsFilter}/>
          }
          {
              permissionsAccess("elastic.facets.client.cashbox") &&
              <ClientFilters
                text="Подразделения"
                values={filters.selectedCashboxes}
                onChange={(v) => handleFilterChange('selectedCashboxes', v)}
            />
          }
          {
            accessFeatures["branches"] && permissionsAccess("elastic.facets.client.branch") &&
              <ClientFilters
                text="Филиалы"
                values={filters.selectedBranches}
                onChange={(v) => handleFilterChange('selectedBranches', v)}
            />
          }
        </div>
        <div className="content-inner-data-container fullwidth">
          <div className="content-datatable">
            <div className="content-datatable-header ">
              <div className="d-flex flex-column align-center  fullwidth">
                <div className="content-datatable-header-actions d-flex flex-space-between">
                  <div className="content-datatable-header-search">
                    <input
                      className="input fullwidth"
                      type="text"
                      name="globalSearch"
                      id="globalSearch"
                      placeholder="Найти клиента"
                      autoComplete="off"
                      value={term}
                      onChange={onChange}
                      onKeyUp={triggerSearchInput}
                    />
                  </div>
                  {
                    permissionsAccess("action.sms.bulk") &&
                    <ActionButton text="Отправить СМС" func={openClientsListForNotification} />
                  }
                  {
                    permissionsAccess("action.client.union") &&
                    <ActionButton
                      styleName={openClientToNotificationList ? 'disabled-action-item' : 'action-item'}
                      text="Объединить анкеты"
                      func={handleCombineProfiles}
                    />
                  }
                  {
                    permissionsAccess("elastic.facets.client.creation_date") &&
                    <AppDatePicker
                      coverClass="form-element"
                      startDate={filters.timeRange.startDate}
                      endDate={filters.timeRange.endDate}
                      onChange={(v) => handleFilterChange('timeRange', v)}
                    />
                  }
                </div>
              </div>
            </div>
            <div className="content-datatable-content">
              <div className="search-facets">
                <div className="search-facets-pillboxes">
                  {filters.term && (
                    <button type="button" className="search-facet" onClick={resetTerm}>
                      <span className="not-crossed">{filters.term}</span>
                      <span className="icon">
                        <CrossSmallIcon />
                      </span>
                    </button>
                  )}
                  { permissionsAccess("elastic.facets.client.total") &&
                      <>
                      <button type="button" className="search-facet" onClick={resetAmount}>
                        <span className="not-crossed">
                          Микрозайм: {filters.amountRangeMinMax[0]} - {filters.amountRangeMinMax[1]}
                        </span>
                        <span className="icon">
                          <CrossSmallIcon />
                        </span>
                      </button>
                      <button type="button" className="search-facet" onClick={resetRequests}>
                        <span className="not-crossed">
                          Обращения: {filters.requestsRangeMinMax[0]} -{' '}
                          {filters.requestsRangeMinMax[1]}
                        </span>
                        <span className="icon">
                          <CrossSmallIcon />
                        </span>
                      </button>
                    </>
                  }
                  {(filters.timeRange.startDate || filters.timeRange.endDate) && (
                    <button type="button" className="search-facet" onClick={resetDate}>
                      <span className="not-crossed">
                        Период: {toDisplayDate(filters.timeRange.startDate)} -{' '}
                        {toDisplayDate(filters.timeRange.endDate)}
                      </span>
                      <span className="icon">
                        <CrossSmallIcon />
                      </span>
                    </button>
                  )}
                  {clientFacetData &&
                    getActiveFacets(clientFacetData.cashboxes, filters.selectedCashboxes).map(
                      (facet) => (
                        <button
                          key={facet}
                          type="button"
                          className="search-facet"
                          onClick={() =>
                            handleFilterChange('selectedCashboxes', {
                              ...filters.selectedCashboxes,
                              [facet]: false,
                            })
                          }>
                          <span className="not-crossed">{facet}</span>
                          <span className="icon">
                            <CrossSmallIcon />
                          </span>
                        </button>
                      ),
                    )}
                  {clientFacetData &&
                      getActiveFacets(clientFacetData.branches, filters.selectedBranches).map(
                          (facet) => (
                              <button
                                  key={facet}
                                  type="button"
                                  className="search-facet"
                                  onClick={() =>
                                      handleFilterChange('selectedBranches', {
                                        ...filters.selectedBranches,
                                        [facet]: false,
                                      })
                                  }>
                                <span className="not-crossed">{facet}</span>
                                <span className="icon">
                            <CrossSmallIcon />
                          </span>
                              </button>
                          ),
                      )}
                </div>
              </div>
              {isLoadingPageClientSearch || loading ? (
                <SearchLoader />
              ) : (
                <table className="table hover">
                  <thead>
                    <tr>
                      <th scope="col">
                        <Checkbox
                          label="Ф.И.О"
                          id="checkboxFullNameSelectAll"
                          name="checkboxFullNameSelectAll"
                          onChange={handleAllClientCheck}
                          value={allChecked}
                        />
                      </th>
                      <th scope="col">Документ</th>
                      <th scope="col">Идентификационный номер</th>
                      <th scope="col">Телефон</th>
                    </tr>
                  </thead>
                  <tbody>
                    {empty &&
                      customerSearchResults.clients.map((client, idx) => {
                        let contact;
                        if (client.contact ) {
                          contact = client.contact.find((tel) => tel.active);
                        }
                        return (
                          <tr key={client.id} className={client.active ? '' : 'disabled'}>
                            <td>
                              <span className="caption">Ф.И.О.</span>
                              <div className="table-cellcontent">
                                <Checkbox
                                  id={client.id}
                                  name={client.id}
                                  onChange={handleClientCheck}
                                  value={markedClients[idx]?.check}
                                />
                                <p>
                                  <Link
                                    className="table-link"
                                    to={`/client/${client.id}`}>
                                    <span>{client.fullName}</span>
                                  </Link>
                                </p>
                              </div>
                            </td>
                            <td>
                              <span className="caption">Документ</span>
                              <p>{client.document}</p>
                            </td>
                            <td>
                              <span className="caption">Идентификационный номер</span>
                              <p>{client.personal}</p>
                            </td>
                            <td>
                              <span className="caption">Телефон</span>
                              {contact && (
                                <p>
                                  <a className="table-phone" href={`tel:${contact.phone}`}>
                                    <span>{contact.phone}</span>
                                  </a>
                                </p>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    {customerSearchResults && customerSearchResults.clients.length === 0 && (
                      <tr>
                        <td colSpan={4}>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}>
                            <div style={{ width: '60px' }}>
                              <NothingFoundImage />
                            </div>
                            <div style={{ marginLeft: '100px' }}>
                              По данному запросу ничего не найдено.
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
      {/*todo replace pagination with lazy load*/}
      <Pagination
        total={calculateTotalPages(customerSearchResults?.total, clientFacetData?.pageRange)}
        current={getCurrentPage(filters.currentPage, calculateTotalPages(customerSearchResults?.total, clientFacetData?.pageRange))}
        handlePageChange={(page) => handleFilterChange('currentPage', page)}
      />
      <AlertModal
        isOpen={popup.isOpen}
        handleClose={closeAlertModal}
        header={popup.header}
        text={popup.text}
      />
      <CombineProfileModal
        isOpen={combineProfiles.isOpen}
        data={combineProfiles.data}
        handleCloseModal={handleCloseModal}
        handleSubmit={submitProfiles}
      />
    </>
  );
};

function toDisplayDate(momentDate) {
  return momentDate ? momentDate.format('DD-MM-yyyy') : null;
}

export default ClientsSearchResults;
